import { useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	onClick: () => void;
	iconBg: string;
	iconColor: string;
	Icon: LucideIcon;
	title: string;
	subtitle: string;
	hasDivider?: boolean;
};

export const PinContractChoiceRow: FC<Props> = ({
	onClick,
	iconBg,
	iconColor,
	Icon,
	title,
	subtitle,
	hasDivider,
}) => {
	const theme = useTheme();

	return (
		<ListRow
			onClick={onClick}
			icon={<Icon size={theme.iconSize.md} color={iconColor} />}
			iconBg={iconBg}
			title={title}
			subtitle={subtitle}
			isLast={!hasDivider}
		/>
	);
};
